/*
 * Privat/Erhverv-kundetype state.
 * Kilde: localStorage['lw-customer'] = 'privat' (default) | 'erhverv'.
 * Spejles til <html data-customer="..."> så CSS kan skifte moms-visning.
 * Attributten sættes desuden af et inline no-flash script i <head> (theme.liquid)
 * FØR første paint — dette modul håndterer klik + event-dispatch efter load.
 */
(() => {
  const KEY = 'lw-customer';
  const VALID = ['privat', 'erhverv'];

  const read = () => {
    try {
      const v = localStorage.getItem(KEY);
      return VALID.includes(v) ? v : 'privat';
    } catch (e) {
      return 'privat';
    }
  };

  const apply = (type) => {
    document.documentElement.dataset.customer = type;
    document.querySelectorAll('[data-customer-toggle]').forEach((btn) => {
      btn.setAttribute('aria-pressed', String(btn.dataset.customerToggle === type));
    });
  };

  const set = (type) => {
    if (!VALID.includes(type)) return;
    try {
      localStorage.setItem(KEY, type);
      localStorage.setItem('lw-customer-chosen', '1');
    } catch (e) {
      /* privatliv-tilstand / fuld storage — fortsæt uden persistering */
    }
    apply(type);
    window.dispatchEvent(new CustomEvent('lw:customer-change', { detail: { type } }));
  };

  // Sync UI med gemt state (no-flash-scriptet har allerede sat <html>-attributten).
  // Kør flere gange: headeren kan re-render'es efter script-load (custom elements
  // hydrerer, soft-nav), hvilket ellers ville nulstille aria-pressed til liquid-default.
  const syncButtons = () => apply(read());
  syncButtons();
  window.addEventListener('load', syncButtons);
  window.addEventListener('pageshow', syncButtons);
  document.addEventListener('shopify:section:load', syncButtons);

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-customer-toggle]');
    if (!btn) return;
    set(btn.dataset.customerToggle);
  });

  // Eksponér til debugging / anden kode.
  window.lwCustomer = { get: read, set };
})();
